import axios from 'axios';

export const LOAD_JEWELS = 'LOAD_JEWELS';
export const LOAD_JEWELS_FILTERS = 'LOAD_JEWELS_FILTERS';
export const SET_JEWELS_SELECTED_FILTERS = 'SET_JEWELS_SELECTED_FILTERS';
export const SET_JEWELS_LENGTH = 'SET_JEWELS_LENGTH';
export const SET_JEWELS_CURRENTPAGE = 'SET_JEWELS_CURRENTPAGE';
export const LOAD_JEWELS_FAVORITE = 'LOAD_JEWELS_FAVORITE';



export const loadJewels = () => {
    return (dispatch, getState) => {
        const jewelsState = getState().jewels;
       
        axios.get("jewels", { params:{ length: jewelsState.length, start: (jewelsState.currentpage*jewelsState.length), filters:jewelsState.selectedfilters }}).then(res =>{
            dispatch({
                type: LOAD_JEWELS,
                payload: res.data
            });
        });
    }  
};


export const loadFilters = () => {
    return dispatch => {
        axios.get("jewels/filters").then(res =>{
            dispatch({
                type: LOAD_JEWELS_FILTERS,
                payload: res.data
            });
        });
    }  
};

export const toggleFavorite = (markid) => {
    return dispatch => {
        axios.post(`jewels/favorites/${markid}`).then(res =>{
            dispatch({
                type: LOAD_JEWELS_FAVORITE,
                payload: res.data
            });
        });
    }  
};

export const loadFavorite = () => {
    return dispatch => {
        axios.get("jewels/favorites").then(res =>{
            dispatch({
                type: LOAD_JEWELS_FAVORITE,
                payload: res.data
            });
        });
    }  
};

export const setCurrentPage = (page) => {
    return{
                type: SET_JEWELS_CURRENTPAGE,
                payload: page
    }
};

export const setLength = (length) => {
    return{
                type: SET_JEWELS_LENGTH,
                payload:length
    }
};


export const setSelectedFilters = (filtername, filters) => {
    return {
                type: SET_JEWELS_SELECTED_FILTERS,
                payload: {
                    filtername,
                    filters
                }
    }  
};